{
  "statusPill": {
    "new": "新建",
    "planning": "规划中",
    "dataPrep": "数据准备",
    "reportGen": "报告生成",
    "complete": "已完成",
    "archived": "已归档"
  },
  "planItemEditor": {
    "edit": "编辑",
    "save": "保存",
    "cancel": "取消",
    "saving": "保存中…",
    "title": "标题",
    "description": "说明",
    "method": "方法",
    "expectedOutput": "预期产出",
    "required": "此项不能为空。",
    "readTitle": "标题",
    "readDescription": "涵盖内容",
    "readMethod": "方法",
    "readExpectedOutput": "预期产出"
  },
  "acceptGap": {
    "modal": {
      "title": "将该章节接受为数据缺口",
      "body": "将本章节作为缺口接受并锁定。如果该章节已有内容，报告将保留这些内容并标记为「已接受 — 未修订」。如果没有内容，报告将在该位置显示「已接受 — 无内容」。请简要说明原因，以便审阅者了解该章节为何无法完成。",
      "placeholder": "为什么将本章节作为缺口接受？",
      "cancel": "取消",
      "confirm": "接受为缺口",
      "submitting": "正在接受……"
    }
  },
  "list": {
    "title": "工作区",
    "empty": "尚无工作区",
    "emptyHint": "创建您的第一个工作区以开始使用。",
    "loading": "正在加载工作区……",
    "loadFailed": "加载工作区失败。请刷新页面。",
    "createButton": "创建工作区",
    "search": "搜索工作区",
    "searchPlaceholder": "搜索项目……",
    "lastModified": "最近修改",
    "createdAt": "创建于 {{date}}",
    "deleteConfirmTitle": "删除该工作区？",
    "deleteConfirmBody": "此操作将永久删除该工作区、其文件、计划及生成的全部内容，且无法撤销。",
    "delete": "删除",
    "cancel": "取消",
    "welcome": "欢迎回来！",
    "welcomeSubtitle": "开始一个新项目或继续之前的工作。",
    "yourProjectsTab": "您的项目",
    "loadingProjects": "正在加载项目……",
    "projectsHeading": "您的项目",
    "projectsCount_one": "{{count}} 个项目",
    "projectsCount_other": "{{count}} 个项目",
    "noProjects": "创建项目后，它们将显示在此处。",
    "viewLabel": "查看",
    "editLabel": "编辑",
    "archiveLabel": "归档",
    "ariaView": "查看 {{name}}",
    "ariaEdit": "编辑 {{name}}",
    "ariaArchive": "归档 {{name}}",
    "projectsCount": "{{count}} 个项目"
  },
  "create": {
    "title": "创建工作区",
    "namePlaceholder": "输入一个描述性的项目名称",
    "nameLabel": "项目名称",
    "descriptionLabel": "描述",
    "descriptionPlaceholder": "描述本项目的目的与范围",
    "verticalLabel": "业务领域",
    "serviceTypeLabel": "服务类型",
    "outputLanguage": "报告语言",
    "outputLanguageHint": "生成的报告将以该语言撰写。创建后不可更改。",
    "strictness": "发现严格度",
    "strictnessLenient": "宽松",
    "strictnessBalanced": "均衡（推荐）",
    "strictnessStrict": "严格",
    "strictnessHint": "标记发现的严格程度。宽松 = 仅标记对监管结论有实质影响的问题。严格 = 标记每一个独立偏差，包括呈现与可追溯性。默认为均衡。创建后不可更改。",
    "aggregation": "问题聚合",
    "aggregationConsolidated": "合并",
    "aggregationBalanced": "均衡（推荐）",
    "aggregationGranular": "细粒度",
    "aggregationHint": "问题日志中发现的分组方式。合并 = 更少、更宽泛的根因问题。细粒度 = 每个独立发现作为单独问题。默认为均衡。创建后不可更改。",
    "submit": "创建",
    "cancel": "取消",
    "creating": "正在创建……",
    "errorGeneric": "无法创建工作区。",
    "errorTimedOut": "本次操作耗时过长。项目可能尚未创建，请先重新打开项目列表确认，然后再重试。",
    "nameRequired": "工作区名称为必填项。",
    "newProjectTitle": "创建新项目",
    "newProjectSubtitle": "为您的项目命名并填写描述以开始。",
    "editProjectTitle": "编辑项目",
    "editProjectSubtitle": "在下方更新您的项目信息。",
    "selectedWorkType": "已选工作类型",
    "createButton": "创建项目",
    "saveChanges": "保存更改",
    "newProject": "+ 新建项目",
    "inheritedFrom": "继承自",
    "scopeLabel": "范围",
    "landingNote": "创建后将进入项目工作区"
  },
  "archive": {
    "title": "归档该项目？",
    "body": "此操作将把 <strong>{{name}}</strong> 归档，并将其从活跃项目中移除。您可稍后从归档中恢复。",
    "cancel": "取消",
    "confirm": "归档"
  },
  "card": {
    "openButton": "打开",
    "deleteButton": "删除",
    "renameButton": "重命名",
    "duplicateButton": "复制",
    "stageLabel": "阶段",
    "filesLabel": "文件",
    "filesCount_one": "{{count}} 个文件",
    "filesCount_other": "{{count}} 个文件"
  },
  "files": {
    "referencesPartiallyMapped": "引用映射部分完成——下次变更时将重试。",
    "referencesOverCap": "此工作区过大，无法进行跨文件关系映射（最多映射 200 个源文件）。您的文件仍已完整编入索引，可供搜索。",
    "title": "文件",
    "panelTitle": "数据源",
    "viewFileMetadataTooltip": "查看文件元数据",
    "ariaViewFileMetadata": "查看文件元数据",
    "ariaRetryProcessing": "重试文件处理",
    "ariaRemoveFile": "移除文件",
    "empty": "尚未上传任何文件",
    "emptyHint": "将文件拖放至此或点击浏览。",
    "uploadButton": "上传文件",
    "browseButton": "浏览",
    "dropHere": "拖放文件以上传",
    "dropHint": "PDF、DOCX、XLSX、CSV、TXT、MD、图片",
    "uploading": "正在上传……",
    "uploadFailed": "上传失败",
    "uploadSuccess": "上传完成",
    "deleteFile": "删除文件",
    "deleteFileConfirm": "删除 {{name}}?",
    "deleteFileConfirmBody": "该文件将从工作区移除。",
    "openFile": "打开",
    "downloadFile": "下载",
    "renameFile": "重命名",
    "metadataButton": "元数据",
    "reviewMetadataButton": "审阅元数据",
    "extractedFiles": "提取的文件",
    "filesUploaded_one": "已上传 {{count}} 个文件",
    "filesUploaded_other": "已上传 {{count}} 个文件",
    "fileTooLarge": "文件过大（最大 {{max}}）。",
    "unsupportedType": "不支持的文件类型。",
    "selectFiles": "选择文件",
    "fileName": "文件名",
    "fileSize": "大小",
    "fileType": "类型",
    "fileStatus": "状态",
    "fileActions": "操作",
    "category": "类别",
    "uncategorized": "未分类",
    "uploadProgress": "{{name}} ({{percent}}%)",
    "approveFiles": "批准文件",
    "approveAndContinue": "批准并继续",
    "approving": "正在批准……",
    "rejectFile": "拒绝",
    "approveFile": "批准",
    "fileMissingMetadata": "缺少元数据",
    "fileNeedsAttention": "需要关注",
    "fileReady": "就绪",
    "fileEnriching": "正在丰富……"
  },
  "metadata": {
    "title": "文件元数据",
    "reviewTitle": "审阅文件元数据",
    "reviewSubtitle": "继续前请确认每个文件的自动检测元数据。",
    "categoryLabel": "类别",
    "sourceLabel": "来源",
    "descriptionLabel": "描述",
    "descriptionPlaceholder": "该文件包含什么内容？",
    "keyTopicsLabel": "关键主题",
    "tagsLabel": "标签",
    "save": "保存",
    "cancel": "取消",
    "approveAll": "全部批准",
    "approveAllAndContinue": "全部批准并继续",
    "needsReview": "需要审阅",
    "approved": "已批准",
    "approvedCount": "已批准 {{approved}} / {{total}}",
    "saving": "正在保存……",
    "saveFailed": "无法保存元数据。",
    "noFiles": "无文件可供审阅。",
    "fileTypeLabel": "文件类型",
    "dataTypeLabel": "数据类型",
    "coversSectionsLabel": "覆盖章节",
    "loadingMetadata": "正在加载元数据……",
    "notRecorded": "— 未记录",
    "extractedFromTitle": "从此文件中提取",
    "selectAll": "全选",
    "clearSelection": "清除选择",
    "filesSelected_one": "已选择 {{count}} 个文件",
    "filesSelected_other": "已选择 {{count}} 个文件",
    "fields": {
      "documentRole": "文档角色",
      "documentRoleHelp": "该文档扮演什么角色？",
      "contentDescription": "内容描述",
      "dataType": "数据类型",
      "contentCategory": "内容类别",
      "keyTopics": "关键主题",
      "relevantSections": "相关章节",
      "dataFormat": "数据格式"
    },
    "fieldLabels": {
      "content_description": "内容描述",
      "data_type": "数据类型",
      "document_role": "文档角色",
      "source_type": "来源类型",
      "author_or_source": "作者 / 来源",
      "reporting_period": "报告期间",
      "document_version": "文档版本",
      "key_topics": "关键主题",
      "regulatory_frameworks": "监管框架",
      "user_description": "用户描述",
      "content_category": "内容类别",
      "data_format": "数据格式",
      "has_tables": "包含表格",
      "is_prior_period": "前期数据",
      "source_sections": "来源章节",
      "upload_source": "上传来源",
      "row_count": "行数",
      "column_names": "列",
      "classification_kind": "检测到的格式"
    },
    "fieldDescriptions": {
      "source_sections": "原始来源报告中的章节标识符列表",
      "target_template_section_ids": "该文件对应的模板章节 ID 列表",
      "data_requirements_matched": "该文件满足的数据要求列表",
      "key_topics": "文件中的关键主题和实体",
      "has_tables": "文件是否包含表格数据",
      "table_count": "发现的表格数量",
      "author_or_source": "作者、团队或来源系统/供应商",
      "source_type": "文件来源的分类",
      "reporting_period": "文件涵盖的报告期间",
      "is_prior_period": "是否包含前期数据",
      "document_version": "文档的版本标识",
      "regulatory_frameworks": "适用的监管框架",
      "upload_source": "该文件进入工作区的方式",
      "content_description": "对该文件内容的简要描述",
      "data_type": "文件所含数据的类型",
      "document_role": "该文件在您的报告中的作用",
      "user_description": "您对该文件的描述",
      "content_category": "文件内容所属的类别",
      "data_format": "数据的存储格式",
      "row_count": "文件中的行数",
      "column_names": "文件中各列的名称",
      "classification_kind": "系统对文件内容的分类结果"
    },
    "enumValues": {
      "upload_source": {
        "user_upload": "用户上传",
        "user_upload_sas": "用户上传（大文件）",
        "toolbox_extractor_import": "工具箱：Extractor 导入",
        "toolbox_gatekeeper_import": "工具箱：Gatekeeper 导入",
        "toolbox_reggie_import": "工具箱：测试场导入"
      },
      "document_role": {
        "model_documentation": "模型文档",
        "regulatory_framework": "监管框架",
        "test_data": "测试数据",
        "test_results": "测试结果",
        "historical_report": "历史报告",
        "supplementary": "补充材料",
        "code_artifact": "代码制品"
      },
      "data_type": {
        "unstructured": "非结构化",
        "structured": "结构化",
        "image": "图像"
      },
      "source_type": {
        "internal_report": "内部报告",
        "regulatory_document": "监管文档",
        "vendor_material": "供应商材料",
        "model_documentation_package": "模型文档包",
        "data_file": "数据文件",
        "other": "其他"
      },
      "file_format": {
        "pdf": "PDF",
        "docx": "Word 文档",
        "xlsx": "Excel 表格",
        "csv": "CSV",
        "txt": "文本",
        "other": "其他"
      },
      "section_type": {
        "report": "报告",
        "test_run": "测试运行",
        "table": "表格",
        "verbatim": "原文"
      }
    }
  },
  "tasks": {
    "descriptionLabel": "任务描述",
    "descriptionPlaceholder": "描述您希望产出的内容。",
    "saveTaskButton": "保存任务",
    "saved": "已保存",
    "saving": "正在保存……",
    "saveFailed": "无法保存任务。",
    "templateLabel": "输出模板",
    "templatePlaceholder": "可选：粘贴一个示例模板或大纲。",
    "saveTemplateButton": "保存模板",
    "uploadTemplateButton": "上传模板",
    "removeTemplateButton": "移除模板"
  },
  "uploadFlow": {
    "step": {
      "upload": "上传",
      "metadataReview": "审阅元数据",
      "confirm": "确认并摄取"
    }
  },
  "evidenceMap": {
    "title": "证据图谱",
    "subtitle": "将每个计划章节追溯到支持它的源文件。",
    "noEvidence": "尚无可用证据。",
    "loading": "正在加载证据图谱……",
    "close": "关闭",
    "viewSource": "查看来源",
    "section": "章节",
    "sources": "来源",
    "coverage": "覆盖度"
  },
  "issueLog": {
    "panelTitle": "问题日志",
    "ariaLabel": "问题日志",
    "exportCsv": "导出 CSV",
    "exporting": "正在导出……",
    "exportTooltip": "下载 CSV（忽略当前严重度筛选）",
    "scopeUnattributed_one": "本次分析中有 {{count}} 个问题未关联到计划条目，未在此处显示。",
    "scopeUnattributed_other": "本次分析中有 {{count}} 个问题未关联到计划条目，未在此处显示。",
    "csvExportFailed": "CSV 导出失败",
    "ariaCollapse": "收起问题日志",
    "ariaExpand": "展开问题日志",
    "loadingIssueLog": "正在加载问题日志……",
    "updating": "正在更新……",
    "retry": "重试",
    "tableHeaderSeverity": "严重度",
    "tableHeaderFinding": "发现",
    "tableHeaderSection": "章节",
    "tableHeaderGoTo": "跳转至",
    "tableHeaderDetails": "详情",
    "noMatching": "当前严重度筛选下没有匹配的问题。",
    "noIssues": "无问题。",
    "details": "详情",
    "ariaJumpToSection": "前往来源条目 {{id}}",
    "navigationUnavailable": "来源条目不可用。",
    "tooltipJumpToSection": "打开来源条目。",
    "stateLabelPreGate": "报告自检完成后，问题日志将填充。",
    "stateLabelPopulating": "正在准备问题日志……",
    "stateLabelAggregating": "正在综合根因问题……",
    "stateLabelEmpty": "未识别到任何问题。",
    "stateLabelDrift": "问题日志已填充，归因偏差已标记。",
    "stateLabelExtractionPaused": "问题提取已暂停 — 将在下次运行时恢复。",
    "stateLabelPopulated_one": "已综合 {{count}} 个问题。",
    "stateLabelPopulated_other": "已综合 {{count}} 个问题。",
    "sortChip": "排序：严重度 {{direction}}",
    "severityRollup": "{{count}} 个 类型 {{tier}}",
    "stateLabelPopulated": "已填充",
    "supportsValidation": {
      "none_emitted": "该问题为跨领域发现，未附带具体的支持性症状。",
      "partial_invalid": "部分支持性症状引用无法解析。",
      "none_valid": "所有支持性症状引用均无法解析，因此无法显示此问题的症状。"
    },
    "relatedIssuesLabel": "基于：",
    "relatedIssueUnresolved": "不在此日志中的问题",
    "stateLabelFailed": "问题日志编译失败。请重试，或在没有问题日志的情况下继续。",
    "stateLabelVersionFailed": "最新的报告版本未能完成，因此没有对应的问题日志。请生成新版本。",
    "stateLabelSkipped": "无问题日志 — 本报告在没有问题日志的情况下生成。",
    "retryAggregation": "重试问题编译",
    "skipAggregation": "在没有问题日志的情况下继续",
    "tableHeaderFindingId": "编号",
    "tableHeaderStatus": "状态",
    "tableHeaderModelLog": "模型日志",
    "statusReadOnlyExplainer": "此处的状态为只读。请在模型的问题日志中设置。",
    "statusOpen": "未解决",
    "sectionNone": "无章节",
    "openInModelLog": "将此发现添加到模型的问题日志",
    "openInModelLogNoModel": "本项目尚未关联模型，因此没有可添加到的模型问题日志。",
    "openInModelLogUnavailable": "暂不支持将发现添加到模型的问题日志。",
    "loadFailed": "问题日志加载失败。请重试。",
    "stateLabelLoadFailed": "问题日志不可用 — 加载失败。",
    "stateLabelUnknown": "问题日志处于意外状态，内容可能不完整。请重试或联系支持。",
    "openInModelLogNoFindingUid": "此发现没有共享标识，因此无法添加到模型的问题日志中。",
    "escalateFailed": "未能将此发现添加到模型的问题日志中。请重试。",
    "openInModelLogAlreadyAdded": "已在模型的问题日志中。",
    "escalateConfirmTitle": "已添加到模型的问题日志",
    "escalateConfirmBody": "{{issueId}} 现已加入模型的问题日志。",
    "escalateConfirmDismiss": "关闭"
  },
  "references": {
    "panelTitle": "引用",
    "ariaLabel": "引用",
    "ariaCollapse": "收起引用",
    "ariaExpand": "展开引用",
    "loading": "正在加载引用……",
    "rebuilding": "报告正文已变更，参考文献正在重新生成。",
    "retry": "重试",
    "ariaViewMetadata": "查看 {{filename}} 的元数据",
    "dialogTitle": "引用 [{{number}}]",
    "ariaCloseDialog": "关闭引用详情",
    "documentRoleLabel": "文档角色",
    "dataTypeLabel": "数据类型"
  },
  "header": {
    "back": "返回",
    "settings": "设置",
    "exportReport": "导出报告",
    "exporting": "正在导出……",
    "exportFailed": "导出失败。"
  },
  "page": {
    "ariaCollapseSidebar": "收起计划与数据面板",
    "ariaExpandSidebar": "展开计划与数据面板",
    "loadFailed": "加载工作区信息失败。",
    "hydrateLoading": "正在加载项目",
    "hydrateStillWorking": "仍在处理…",
    "hydrateTimedOut": "目前无法打开该项目。没有任何内容被加载，因此此处显示的任何内容都不会是完整的。",
    "hydrateRetry": "重试",
    "notFound": "未找到工作区。正在跳转至项目列表。",
    "filesLoadFailed": "加载工作区文件失败。",
    "sectionsLoadFailed": "加载章节失败。",
    "haltCannotClear": "无法清除停止状态：计划未加载。请重新加载工作区。",
    "testRunCancelled": "测试运行已取消。您可以重新启动或继续报告生成。",
    "testRunCompleted": "测试运行已完成。请审阅结果以继续。",
    "testRunErrored": "测试运行完成但出现错误。请审阅结果了解详情。",
    "sourceUploadFailed": "源文件上传失败。请重试。",
    "sourceUploadPartialFailed": "已上传 {{uploaded}}/{{total}} 个文件。{{failed}} 个失败：{{names}}。请重试失败的文件。",
    "sourceUploadSizeLimitHint": "{{count}} 个文件超出了上传服务器的大小限制——请尝试拆分文件或联系支持人员。",
    "metadataEnrichmentFailed": "元数据丰富化失败。请重试。",
    "taskUploadFailed": "任务描述上传失败。请重试。",
    "templateUploadFailed": "输出模板上传失败。请重试。",
    "taskDeleteFailed": "删除任务描述失败。请重试。",
    "templateDeleteFailed": "删除输出模板失败。请重试。",
    "mdrPromotionFailed": "模型开发报告无法添加到来源集合。请将其作为来源文件重新上传。",
    "planGenTimeout": "计划生成超时。请重试。",
    "enrichmentPartialWarning": "部分章节未能完全充实（已完全充实 {{enrichedCount}}/{{total}}）。报告生成将基于可用详细信息继续进行。",
    "planApprovalFailed": "计划批准失败。请重试。",
    "planFeedbackFailed": "计划反馈更新失败。请重试。",
    "planRefreshFailed": "计划可能未反映最新更改。请尝试刷新。",
    "reportGenFailed": "报告生成失败。请重试。",
    "progressTrackingError": "进度跟踪出错。请重试。",
    "deleteFilesFailed_one": "删除 {{count}} 个文件失败。{{detail}}",
    "deleteFilesFailed_other": "删除 {{count}} 个文件失败。{{detail}}",
    "haltDefaultMessage": "章节生成因上游问题已暂停。请清除停止状态并重试以恢复。",
    "haltDefaultPrompt": "章节生成已暂停。",
    "testRunInProgress": "测试运行进行中",
    "executingTestGroup": "正在执行测试组 {{current}}/{{total}}",
    "executingTestGroupNamed": "正在执行测试组 {{current}}/{{total}}:{{name}}",
    "executingTestGroups": "正在执行测试组……",
    "cancelling": "正在取消……",
    "cancelTestRun": "取消测试运行",
    "exportSuccess": "报告导出成功。",
    "noSectionsToExport": "无可导出的章节。请先生成章节。",
    "exportFailedRetry": "导出失败。请重试。",
    "exportFailedTitle": "无法下载您的报告",
    "exportTimedOut": "报告准备时间过长，我们已停止等待。未做任何更改——请选择「下载」重试。",
    "cannotExportSections_one": "无法导出：{{count}} 个章节尚未就绪",
    "cannotExportSections_other": "无法导出：{{count}} 个章节尚未就绪",
    "noSectionsToExportShort": "无可导出的章节",
    "sectionsNotReady": "尚未就绪的章节：",
    "regenerateOrWait": "请重新生成失败的章节，或等待进行中的生成完成后再导出。",
    "exportBlockedGeneratingTitle": "章节仍在生成中",
    "sectionsStillGenerating": "正在生成：",
    "waitForGenerationToFinish": "这些章节生成完成后即可下载。",
    "ariaDismissExportError": "关闭导出错误提示",
    "exportBlockedInProgress": "导出被阻止：部分章节仍在生成中。请等待完成。",
    "dataGapSuffix_one": " （{{count}} 个章节包含数据缺口：{{names}}。请在文档中查看 [DATA GAP] 标记。）",
    "dataGapSuffix_other": " （{{count}} 个章节包含数据缺口：{{names}}。请在文档中查看 [DATA GAP] 标记。）",
    "etlTimeout": "处理时间超出预期。数据摄取可能仍在进行中。",
    "etlFailedFiles": "摄取失败——{{count}} 个文件出现错误。重试以重新摄取整个工作区。",
    "cannotExportSections": "无法导出 — 没有已自检的章节。",
    "dataGapSuffix": " — {{count}} 个章节被标记为数据缺口：{{names}}",
    "deleteFilesFailed": "删除 {{count}} 个文件失败",
    "holisticPausedAlert_one": "整体自检已暂停 — 还有 <strong>{{count}} 个章节</strong>需要通过自检后，报告才能完成。点击每个失败章节上的 <strong>{{retryAction}}</strong>（或使用报告底部的 <strong>{{bulkAction}}</strong>）再次尝试。若某章节无法恢复，请点击该章节上的 <strong>{{acceptGapAction}}</strong> 以继续发布报告：已有内容的章节将保留其内容并标记为「已接受 — 未修订」，没有内容的章节则在该位置显示「已接受 — 无内容」。",
    "holisticPausedAlert_other": "整体自检已暂停 — 还有 <strong>{{count}} 个章节</strong>需要通过自检后，报告才能完成。点击每个失败章节上的 <strong>{{retryAction}}</strong>（或使用报告底部的 <strong>{{bulkAction}}</strong>）再次尝试。若某章节无法恢复，请点击该章节上的 <strong>{{acceptGapAction}}</strong> 以继续发布报告：已有内容的章节将保留其内容并标记为「已接受 — 未修订」，没有内容的章节则在该位置显示「已接受 — 无内容」。",
    "chatError": {
      "agent_timeout": "助手响应时间过长。请重试。",
      "agent_crash": "助手遇到错误。请重试。",
      "tool_call_failed": "工具操作遇到错误。请重试。",
      "retrieval_miss": "在您的工作区中未找到相关信息。",
      "context_overflow": "对话内容过长。请开启新对话。",
      "concierge_classify_error": "无法理解您的请求。请重新表述后再试。",
      "workflow_state_guard": "当前工作区阶段不允许此操作。",
      "validation_error": "您的请求中存在无效字段。请检查后重试。",
      "not_found": "未找到该工作区或计划。",
      "unauthorized": "您无权访问此资源。",
      "provider_error": "AI 服务提供商当前不可用。请稍后重试。",
      "plan_revision_unmatched_sections": "无法完成此修改：修改中引用了您的计划中不存在的章节。您的计划未作任何更改，请指明要修改的章节后重试。",
      "plan_revision_unmatched_sections_de_checklist": "无法应用此修改，因为它引用了设计有效性检查清单中不存在的项目。未作任何更改。请指明要修改的检查清单项目后重试。",
      "plan_revision_unmatched_sections_oe_checklist": "无法应用此修改，因为它引用了运行有效性检查清单中不存在的项目。未作任何更改。请指明要修改的检查清单项目后重试。",
      "plan_revision_duplicate_sections": "无法完成此修改：修改中多次引用了同一章节。您的计划未作任何更改，请重试。",
      "plan_revision_integrity_failed": "修订未通过计划完整性检查。您的计划未改变。请说明您希望进行的修改。",
      "plan_revision_saved_response_failed": "您的修订已保存，但确认失败。请先查看已保存的计划，再请求其他修改。",
      "ingest_in_progress": "此工作区正在添加新的证据。请在证据导入完成后重试。",
      "audit_gate_unavailable": "暂时无法确认是否仍在添加新的证据。请稍后重试。",
      "plan_already_approved": "此计划已获批准并已锁定，无法再更改。",
      "plan_already_approved_report": "报告计划已获批准并已锁定，无法再更改。",
      "plan_already_approved_de_checklist": "设计有效性检查清单已获批准并已锁定，无法再更改。",
      "plan_already_approved_oe_checklist": "运行有效性检查清单已获批准并已锁定，无法再更改。",
      "plan_version_conflict": "此计划在您上次查看后已被更改，因此未作任何修改。现已显示最新版本，请查看后重新发送您的请求。",
      "plan_version_conflict_report": "报告计划在您上次查看后已被更改，因此未作任何修改。现已显示最新版本，请查看后重新发送您的请求。",
      "plan_version_conflict_de_checklist": "设计有效性检查清单在您上次查看后已被更改，因此未作任何修改。现已显示最新版本，请查看后重新发送您的请求。",
      "plan_version_conflict_oe_checklist": "运行有效性检查清单在您上次查看后已被更改，因此未作任何修改。现已显示最新版本，请查看后重新发送您的请求。",
      "workspace_terminal": "此项目已完成且为只读状态，无法再修改。您仍可就其提问。",
      "workspace_archived": "该工作区已归档，为只读状态，无法再修改。",
      "workspace_model_archived": "该工作区所属的模型已归档，因此工作区为只读状态，无法再修改。",
      "workspace_deleting": "该工作区正在删除中，因此无法再修改。",
      "content_filtered": "助手拒绝回应此请求。",
      "unknown": "发生意外错误。请重试。",
      "run_item_regen_disabled": "设计有效性和运行有效性的结果不能逐项重新生成。如需更改，请更新证据后重新运行整个阶段。"
    },
    "planGenError": {
      "plan_template_status_persist_failed": "计划生成无法保存模板的格式状态。未保存任何计划。请重试。",
      "template_block_labels_missing": "计划生成无法判断模板中哪些页面属于报告内容。未保存任何计划。请重试。",
      "template_block_labels_invalid": "计划生成无法判断模板中哪些页面属于报告内容。未保存任何计划。请重试。",
      "template_block_labels_unknown_id": "计划生成引用了您的模板中不存在的页面。未保存任何计划。请重试。",
      "plan_structure_non_content_blocks_present": "计划生成返回了意外的结构。未保存任何计划。请重试。",
      "template_block_labelling_timeout": "读取您的模板页面耗时过长。未保存任何计划。请重试。",
      "template_block_labelling_failed": "计划生成无法读取您的模板页面。未保存任何计划。请重试。",
      "template_label_contract_violation": "无法为规划准备您的模板。未保存任何计划。请重试。",
      "template_constraint_invalid": "无法为规划准备您的模板。未保存任何计划。请重试。",
      "constraint_extraction_failed": "计划生成无法读取任务描述中的约束条件。未保存任何计划。请重试。",
      "constraint_extraction_timeout": "读取任务描述中的约束条件耗时过长。未保存任何计划。请重试。",
      "mdr_extract_failed": "无法读取此项目的模型开发报告。请重新上传并重新批准该报告（PDF 或 DOCX），然后重试。",
      "audit_scope_extract_failed": "无法读取此项目的其中一份范围文件。请重新上传该文件（PDF、DOCX、Markdown 或 TXT），然后重试。",
      "plan_structure_max_rounds": "计划生成未能完成计划结构。未保存任何计划。请重试。",
      "plan_structure_orphaned": "计划生成产生了缺少上级标题的子章节。未保存任何计划。请重试。",
      "enrichment_timeout": "计划生成在补充章节详情时耗时过长。请重新生成计划。",
      "enrichment_below_threshold": "计划生成未能为足够多的章节补充详情。请重新生成计划。",
      "plan_template_labels_persist_failed": "计划生成无法保存模板的页面布局。未保存任何计划。请重试。",
      "plan_template_outline_invalid": "无法为规划准备您的模板。请从 Microsoft Word 重新导出、重新上传后重试。",
      "template_cleanup_contract_violation": "无法根据此计划准备您的模板。未保存任何计划。请重试。",
      "plan_template_drift": "计划生成遗漏了模板要求的章节。未保存任何计划。请重试。",
      "template_parse_failed": "我们无法读取您的模板。请通过 Microsoft Word 重新导出后再次上传。",
      "missing_task_description": "生成计划前需要任务描述。请上传后重试。",
      "plan_structure_timeout": "计划结构步骤响应时间过长。请重试。",
      "plan_structure_unparseable": "计划结构步骤未返回可用结果。请重试。",
      "plan_merge_drift": "计划丰富化产生了不一致的结果。请重试。",
      "no_sections_generated": "多次尝试后，计划生成仍未产出任何章节。请重试。",
      "plan_persist_failed": "计划生成已完成但无法保存。请重试。",
      "plan_gen_unhandled": "计划生成遇到意外错误。请重试。",
      "recoveredFailed": "计划生成失败。请重试或联系支持。",
      "unknown": "计划生成失败。请重试。",
      "plan_gen_in_progress": "该工作区已有一个计划正在生成中。请等待其完成。",
      "plan_already_exists": "该工作区已存在一个计划。请先删除或修改现有计划，再生成新计划。",
      "enrichment_rate_limited": "计划扩充因速率限制，在多次重试后仍未完成。请重新生成计划。"
    },
    "etlFailedWorkspace": "摄取在完成前失败。没有单个文件报告错误。重试以重新摄取整个工作区。",
    "useAsMdrAction": "用作模型报告",
    "useAsMdrConfirmTitle": "将此报告用作该模型的开发报告",
    "useAsMdrConfirmBody": "此报告将作为该模型开发报告的新版本添加到模型中，等待审批。在有人于模型概览页面批准之前，计划生成会将其作为未批准的草稿参考使用。不会替换也不会删除任何内容——如果这不是正确的报告，请在该页面撤回该版本以将其停用。",
    "useAsMdrConfirmAction": "添加到模型",
    "useAsMdrSubmitting": "正在添加…",
    "useAsMdrUnconfirmed": "此报告已提交至模型，但尚未出现在模型概览页面上。请先在该页面确认，再重新添加。",
    "useAsMdrFailed": "无法将此报告添加到模型。请重试。",
    "haltClearAndRetry": "解除暂停并重试"
  },
  "cards": {
    "retryFromScratch": "从头重试",
    "retrying": "正在重试……",
    "feedback": "反馈",
    "acceptAsGap": "接受为缺口",
    "unreconciledGapTitle": "已接受 — 未修订",
    "unreconciledGapBody": "报告验证器要求修订此章节，但修订未能完成，审阅者已接受此差异。以下内容为此章节未经修订的原始文本。",
    "generationFailed": "生成失败。",
    "contextDegraded": "撰写本节时有部分参考资料未能使用，因此内容可能不完整。请重新生成本节后再试。",
    "figuresNotShown": "撰写本节的模型没有看到本节的图表，因此文字可能没有引用这些图表。请使用能够查看图表的模型重新生成本节，以纳入图表。",
    "generationFailedTransient": "由于服务提供商暂时性问题，生成失败。请稍候片刻后重试。",
    "generationFailedHelper": "生成失败。点击「从头重试」以重新生成该章节。",
    "bulkRegenInProgressTooltip": "批量重新生成正在进行中 — 请等待完成后再重试单个章节。",
    "retryInProgressTooltip": "该章节正在重试中。",
    "uploadSourceFiles": "上传源文件",
    "dropUnreadable": "无法读取拖放的内容。请改用“文件”或“文件夹”按钮。",
    "uploadingFile": "正在上传文件……",
    "uploadingFiles": "正在上传 {{count}} 个文件……",
    "cancelUpload": "取消",
    "filesButton": "文件",
    "folderButton": "文件夹",
    "uploadTip": "提示：请将文件整理到文件夹中（例如 <1>developer/</1>、<2>validator/</2>）。每个工作区最多 200 个源文件。.zip 和 .egp 压缩包会自动解压——可通过“文件”按钮添加或直接拖入。",
    "uploadedFilesHeader": "已上传文件",
    "fileRemovedLabel": "已移除",
    "attentionEnrichmentIncomplete": "注意 — 丰富化未完成",
    "deleteFolderTitle": "删除该文件夹？",
    "deleteFolderBody_one": "此操作将永久删除位于以下位置的 <1>{{count}}</1> 个文件：",
    "deleteFolderBody_other": "此操作将永久删除位于以下位置的 <1>{{count}}</1> 个文件：",
    "deleteFolderHint": "这些文件及其索引内容都将被移除。完整性将在之后重新评估。",
    "deleteFolderConfirm_one": "删除 {{count}} 个文件",
    "deleteFolderConfirm_other": "删除 {{count}} 个文件",
    "deletingProgress": "正在删除……",
    "ariaDeleteFolder": "删除 {{name}} 中的 {{count}} 个文件",
    "testOutputTooltip": "测试输出",
    "autoAddedReference": "自动添加的参考",
    "autoAddedReferenceWithStatus": "自动添加的参考 · {{status}}",
    "statusReady": "就绪",
    "statusReadyLayoutWarning": "已就绪，但部分格式无法读取",
    "statusProcessing": "处理中",
    "statusIngestedAssessmentPending": "已摄取 — 评估待定",
    "statusAwaitingProcessing": "等待处理",
    "statusNeedsReview": "需要审阅",
    "statusIndexingFailed": "索引失败",
    "statusExtractionFailed": "提取失败",
    "statusFailed": "失败",
    "statusDeletionIncomplete": "删除未完成",
    "statusUnknown": "未知",
    "rejectedUnsupportedContent": "未添加 — 不支持此文件类型，或该文件无法作为文本读取",
    "rejectedDefault": "无法添加",
    "uploadedDate": "上传于 {{date}}",
    "uploadedJustNow": "刚刚上传",
    "clickToBrowse": "点击浏览或拖放文件",
    "clickBrowseOrDrop": "点击浏览或拖放文件",
    "dragDropOrButtons": "拖放文件，或使用上方按钮",
    "supportedFileTypesLabel": "支持格式：PDF、DOCX、PPTX、XLSX、XLS、CSV、MD、TXT、RST、IPYNB、JSON、NDJSON、Parquet、图片，以及纯文本源代码 / 配置（PY、R、SQL、JS、TS、HTML、CSS、SH、YAML、TOML、INI、LOG、XML 等）。",
    "planGenSupportedFileTypesLabel": "支持格式：.docx、.pdf、.md、.markdown、.txt",
    "unsupportedPlanGenFile": "此处不支持 {{ext}} 文件 — 请上传 .docx、.pdf、.md、.markdown 或 .txt 文件。",
    "uploadTaskDescriptionLabel": "上传任务描述",
    "uploadOutputTemplateLabel": "上传输出模板",
    "taskDescriptionTitle": "任务描述",
    "taskDescriptionHelp": "包含详细的项目要求：整体目标、约束与合规规则、数据使用指南、预期产出标准，以及其他相关信息。",
    "outputTemplateTitle": "输出模板",
    "outputTemplateHelp": "可选地提供一个模板或现有报告以指导章节结构。如未提供，计划结构将根据任务描述和领域知识推导得出。",
    "outputTemplateOptional": "（可选）",
    "generatePlan": "生成计划",
    "generatingPlan": "正在生成计划……",
    "planReadyCelebrationTitle": "计划已就绪！",
    "planReadyCelebrationSubtitle": "您的执行蓝图已完成",
    "regenerateAllFailed": "重新生成所有失败项",
    "regenerating": "正在重新生成……",
    "bulkRegenStarted": "正在重新生成 {{n}} 个章节",
    "bulkRegenAlready": "已在重新生成 {{n}} 个章节",
    "bulkRegenNone": "没有需要重新生成的失败章节",
    "regenAlreadyRunning": "该工作区已有重新生成任务正在进行中。它将在后台完成，无需再次点击。",
    "regenAlreadyRunningTooltip": "该工作区已有重新生成任务正在进行中 — 请等待完成后再重试该章节。",
    "generationStillRunningTooltip": "生成仍在进行中。",
    "feedbackRegenRunningTooltip": "该章节正在重新生成。请等待完成后再提交反馈。",
    "singleRetryTooltip": "单章节重试正在进行中 — 请等待完成后再重新生成所有失败项。",
    "exportTooltipInProgress": "正在导出……",
    "exportTooltipNeedsSections": "请先生成报告章节",
    "exportTooltipNeedsValidated": "至少需要一个章节达到已自检状态（运行整体自检或按现状接受）后，才能下载",
    "exportTooltipSectionGenerating": "有章节正在重新生成 — 生成完成后即可下载",
    "ariaSourceReference": "源引用",
    "ariaFindingNavigate": "导航至首章节中的 {{findingId}}",
    "ariaImageUnavailable": "图像源提取失败 — 图像不可用",
    "badgeImageUnavailable": "⚠ 图像不可用 — 源提取失败",
    "sectionPhase": {
      "extractingSymptoms": "等待问题汇编",
      "aggregatingIssues": "正在准备问题日志",
      "holisticValidating": "正在自检……",
      "execSumGenerating": "正在生成执行摘要……"
    },
    "unsupportedFormatSkipped": "已跳过不支持的格式：{{names}}",
    "approvedLabel": "已批准",
    "approvingLabel": "正在批准……",
    "approvePlanLabel": "批准计划",
    "previousPlanLabel": "上一版计划",
    "supersededChip": "已被取代",
    "noItemsInPlan": "计划中无任何条目",
    "generatedExecutionPlan": "已生成执行计划",
    "planSummary_one": "我已根据您的文档生成了包含 {{count}} 个条目的计划。",
    "planSummary_other": "我已根据您的文档生成了包含 {{count}} 个条目的计划。",
    "requirementsLabel": "要求",
    "expectedOutputLabel": "预期产出",
    "methodLabel": "方法",
    "testRunChip": "测试运行",
    "testRunBlurb": "本章节为自检生成测试数据 — 不产出报告正文内容。",
    "untitledItem": "（未命名）",
    "execSummaryBlocked": "执行摘要被阻塞",
    "execSummaryWaiting_one": " — 等待 {{count}} 个章节",
    "execSummaryWaiting_other": " — 等待 {{count}} 个章节",
    "execSummaryBlockedDefault": "在所有正文章节达到已自检之前，执行摘要将被阻塞。",
    "execSummaryBlockedTooltip_one": "被 {{count}} 个章节阻塞：{{detail}}",
    "execSummaryBlockedTooltip_other": "被 {{count}} 个章节阻塞：{{detail}}",
    "figureCaption": "源文档中的图示",
    "deleteFolderConfirm": "删除 {{count}} 个文件？",
    "execSummaryBlockedTooltip": "执行摘要暂时无法生成 — 请先完成其他章节。",
    "execSummaryWaiting": "正在等待依赖章节……",
    "planSummary": "计划摘要",
    "reportGenerated": "报告已起草",
    "testRunInProgress": "测试运行进行中……",
    "waitingForDataCheck": "正在等待数据检查……",
    "mappingDocRelationships": "正在映射文档关系……",
    "loadingMethodologyContext": "正在加载方法论上下文……",
    "preparingAnalysis": "正在准备分析……",
    "analyzingDataCoverage": "正在分析数据覆盖度……",
    "finalizingReport": "正在收尾报告……",
    "checkingData": "正在检查数据……",
    "uploadsPausedPipeline": "您的文件处理完成前，暂停上传。",
    "reviewEvidenceAndGenerate": "审阅证据并起草报告",
    "preparingYourReport": "正在起草您的报告",
    "download": "下载",
    "planGen": {
      "buildingBlueprint": "正在构建执行蓝图",
      "phase": {
        "enriching": {
          "label": "正在阅读源材料",
          "description": "阅读已上传的文件以获取结构、上下文和引用。"
        },
        "verifying_plan": {
          "label": "正在审查计划对齐",
          "description": "将报告计划与检测到的覆盖缺口进行交叉核对。"
        },
        "preparing_template": {
          "label": "正在应用模板格式",
          "description": "清理模板、映射占位符并准备样式。"
        },
        "finalizing_template": {
          "label": "正在保存模板",
          "description": "为报告构建保存已清理的模板。"
        },
        "finalizing": {
          "label": "正在收尾",
          "description": "生成每个章节并完成报告正文。"
        }
      }
    },
    "archiveError": {
      "bad_archive": "无法打开“{{archive}}”——文件可能已损坏或并非压缩包。未添加任何内容。",
      "empty_archive": "“{{archive}}”中没有可处理的文件。未添加任何内容。",
      "archive_too_large": "“{{archive}}”过大，无法在浏览器中解压（上限 {{limitMb}} MB）。请在本地解压后上传文件夹。",
      "too_many_members": "“{{archive}}”包含 {{entries}} 个文件，而当前工作区已有 {{existing}} 个——上限为 {{limit}} 个源文件。未添加任何内容。",
      "zip_slip": "“{{archive}}”包含不安全的文件路径，未进行解压。未添加任何内容。",
      "symlink_entry": "“{{archive}}”包含快捷方式/链接项，无法处理。未添加任何内容。",
      "encrypted_archive": "“{{archive}}”已设密码保护。请移除密码后重试。",
      "unsupported_compression": "“{{archive}}”使用了无法读取的压缩格式。请重新保存为标准 zip 后重试。",
      "nested_archive": "“{{archive}}”中嵌套了另一个压缩包（“{{entry}}”）。请先解压它再上传。未添加任何内容。",
      "duplicate_entry": "“{{archive}}”包含重复的文件路径，未进行解压。未添加任何内容。",
      "entry_too_large": "“{{archive}}”中包含超过 {{limitMb}} MB 的文件。未添加任何内容。",
      "compression_ratio": "“{{archive}}”中某个文件解压后体积异常庞大，未进行解压。未添加任何内容。",
      "unsupported_browser": "您的浏览器无法解压压缩包。请在本地解压“{{archive}}”后上传文件夹。",
      "egp_missing_manifest": "“{{archive}}”缺少其 SAS Enterprise Guide 项目文件（project.xml），无法解压。未添加任何内容。",
      "egp_bad_manifest": "“{{archive}}”的 SAS Enterprise Guide 项目文件无法读取。未添加任何内容。",
      "egp_unmapped_member": "“{{archive}}”包含一个其 SAS Enterprise Guide 项目文件未描述的程序（“{{entry}}”）。未添加任何内容。"
    },
    "uploadTip_auditing": "提示：按阶段或控制项将审计证据整理到文件夹中。每个工作区最多 200 个源文件。.zip 和 .egp 压缩包会自动解压——可通过“文件”按钮添加或拖入。",
    "unreconciledGapBody_auditing": "此审计章节曾被要求修订，但修订未完成。审核者已接受该差异。下方内容为未经修订的原文。",
    "generationStopped": "此章节的生成已被您停止。请使用“重试”重新运行。",
    "regenerateAllStopped": "重试已停止的章节",
    "stopGeneration": "停止生成",
    "generateBlockedTestRunning": "测试运行正在进行。请取消或等待其完成后再生成报告。",
    "generateBlockedDataCheck": "正在等待数据检查完成，之后才能开始生成报告。",
    "generateBlockedSectionRetry": "部分章节需要重试。请使用各章节的“重试”按钮。"
  },
  "dialogs": {
    "evidenceMap": {
      "title": "审阅证据图谱",
      "subtitle": "为每个报告章节选择提供证据的文件",
      "loading": "正在加载证据图谱……",
      "noPlanSections": "无可映射的计划章节。请在生成报告前批准计划。",
      "noFiles": "未找到源数据文件。请在生成报告前上传文件。",
      "summary_one": "{{sections}} 个章节，跨 {{files}} 个文件",
      "summary_other": "{{sections}} 个章节，跨 {{files}} 个文件",
      "orphanedChip_one": "{{count}} 个孤立",
      "orphanedChip_other": "{{count}} 个孤立",
      "orphanWarningTitle_one": "{{count}} 个文件未被选入任何章节。",
      "orphanWarningTitle_other": "{{count}} 个文件未被选入任何章节。",
      "orphanWarningBody": "在检索时它们将被降权，但不会被排除。",
      "orphanWarningInstruction": "点击 <1>仍要继续</1> 直接生成，或返回先完成映射。",
      "filesSelected_one": "已选择 {{selected}}/{{total}} 个文件",
      "filesSelected_other": "已选择 {{selected}}/{{total}} 个文件",
      "noFilesChip": "无文件",
      "selectAll": "全部",
      "selectNone": "全不选",
      "expandFolder": "展开文件夹",
      "collapseFolder": "折叠文件夹",
      "footerHint": "在下方调整映射或直接生成 — 孤立文件会被降权，但不会被排除。",
      "cancel": "取消",
      "confirmGenerate": "确认并生成",
      "stillProceed": "仍要继续",
      "ariaCloseDialog": "关闭对话框",
      "filesSelected": "已选择 {{count}} 个文件",
      "orphanWarningTitle": "孤立项",
      "orphanedChip": "孤立",
      "summary": "证据摘要"
    },
    "fileMetadata": {
      "headerEnrich": "丰富您的数据",
      "headerEnriching": "正在丰富您的数据",
      "intro": "描述能帮助 Bennie 丰富元数据并对您的数据建立更深入的理解。上传时可选填 — 您可在丰富化完成后审阅并编辑元数据。",
      "placeholderStructured": "描述各列和数据（可选）……",
      "placeholderGeneric": "简要描述（可选）……",
      "phraseAnalyzing": "正在分析文件结构……",
      "phraseExtracting": "正在提取关键元数据……",
      "phraseIdentifying": "正在识别数据类型……",
      "phraseMapping": "正在映射内容关系……",
      "phraseRetrieval": "正在构建检索提示……",
      "phraseClassifying": "正在分类源材料……",
      "phraseTables": "正在检测内容布局……",
      "phraseHeaders": "正在浏览文件内容……",
      "phraseSignatures": "正在读取文件签名……",
      "phraseScanning": "正在扫描关键主题……",
      "phraseDensity": "正在评估内容密度……",
      "phraseCrossRef": "正在与计划交叉引用……",
      "phraseProfiling": "正在剖析文件内容……",
      "phraseIndexing": "正在索引内容章节……",
      "phraseDescriptors": "正在生成搜索描述符……",
      "phraseCatalog": "正在编目源元数据……",
      "phraseCoverage": "正在评估数据覆盖度……",
      "phraseRetrievalIndex": "正在准备检索索引……",
      "phraseMatching": "正在将文件匹配至章节……",
      "phraseAlmostThere": "即将完成……",
      "headerEnrichmentComplete": "丰富化完成",
      "headerEnrichingData": "正在丰富您的数据",
      "completeWithReview_one": "已丰富 {{enriched}} 个，{{review}} 个需要审阅",
      "completeWithReview_other": "已丰富 {{enriched}} 个，{{review}} 个需要审阅",
      "completeNoReview_one": "已成功丰富 {{count}} 个文件",
      "completeNoReview_other": "已成功丰富 {{count}} 个文件",
      "statusPending": "待处理",
      "statusProcessing": "处理中",
      "statusReady": "就绪",
      "statusNeedsReview": "需要审阅",
      "statusFailed": "未添加",
      "startEnrichment": "开始丰富化",
      "cancel": "取消",
      "ariaCloseDialog": "关闭对话框",
      "closeTooltipRunning": "关闭——数据增强将在后台继续",
      "errorEnrichmentFailed": "丰富化失败。请关闭此对话框并重试。",
      "errorEnrichmentStartFailed": "无法启动丰富化。请关闭此对话框并重试。",
      "errorEnrichmentInProgress": "该工作区的丰富化已在进行中。请关闭此对话框 — 正在运行的任务将完成并自动更新文件列表。",
      "errorEnrichmentUnexpected": "处理过程中发生意外错误。请关闭并重试。",
      "errorPollingUnstable": "丰富化轮询不稳定（{{count}} 次失败）。仍在重试……",
      "errorPollingMaxFailures": "丰富化轮询多次重试后仍失败。请关闭并重新启动丰富化。",
      "statusEnriching": "正在丰富 {{name}}……({{done}}/{{total}})",
      "statusEnrichingMetadata": "正在丰富元数据……({{done}}/{{total}})",
      "statusErrorEnrichment": "丰富化过程中出错",
      "statusErrorProcessing": "处理过程中出错",
      "cancelConfirmTitle": "取消丰富化？",
      "cancelConfirmBody_one": "已有 1 个文件上传完成并正在等待丰富化。",
      "cancelConfirmBody_other": "已有 {{count}} 个文件上传完成并正在等待丰富化。",
      "cancelConfirmQuestion": "您希望如何处理？",
      "discardFiles": "丢弃已上传的文件",
      "discardingFiles": "正在删除文件……",
      "keepForLater": "保留以便稍后丰富化",
      "goBack": "返回",
      "errorDiscardFailed": "删除一个或多个文件失败。请重试。",
      "cancelConfirmBody": "丢弃进行中的元数据更改？",
      "completeNoReview": "完成，无需审阅",
      "completeWithReview": "完成，含审阅项"
    },
    "metadataReview": {
      "title": "审阅已丰富的元数据",
      "ariaCloseDialog": "关闭对话框",
      "closeTooltip": "关闭",
      "closeTooltipRunning": "关闭——处理将在后台继续",
      "instructionsBody": "审阅并编辑每个文件已丰富的元数据。除文件名和类型外，所有字段均可编辑。",
      "ingestData": "摄取数据",
      "ingestInProgressTooltip": "数据处理正在进行中。",
      "ingestNothingTooltip": "请先添加新文件或编辑元数据，然后再摄取。",
      "allFilesRejectedEmpty_one": "该文件无法添加，因此没有可审阅的内容。详情请查看“数据源”卡片。",
      "allFilesRejectedEmpty_other": "这 {{count}} 个文件无法添加，因此没有可审阅的内容。详情请查看“数据源”卡片。",
      "cancel": "取消",
      "close": "关闭",
      "ingestionFailed": "数据摄取启动失败。请关闭并重试。",
      "phraseIngesting": "正在准备您的文件以供分析……",
      "phraseExtractingText": "正在提取文本内容……",
      "phraseParsing": "正在解析文件结构……",
      "phraseIndexingDocs": "正在索引文档……",
      "phraseBuildingIndex": "正在构建搜索索引……",
      "phraseAnalyzingImages": "正在分析图像与 OCR……",
      "phraseDataReady": "全部就绪！您的数据已准备好。",
      "phraseDataCompleteness": "数据完整性检查进行中……",
      "phraseDataCoverage": "正在评估数据覆盖度……",
      "phraseMatchingPlan": "正在将文件匹配至计划章节……",
      "phaseChipETLComplete": "ETL 已完成",
      "phaseChipPhase2": "第 2 阶段 — 索引",
      "phaseChipPhase1Complete": "第 1 阶段已完成",
      "phaseChipPhase1": "第 1 阶段 — 摄取",
      "phaseChipFailed": "失败",
      "phaseLibrarianRunning": "正在映射文档关系……",
      "phaseMappingReferences": "正在加载方法论上下文……",
      "phasePromptBuilding": "正在准备分析……",
      "phaseLLMCall": "正在分析数据覆盖度……",
      "phaseParsing": "正在收尾报告……",
      "phaseDefault": "正在评估数据覆盖度……",
      "headerDataReady": "数据就绪",
      "headerDataReadyPartial": "数据就绪——{{count}} 个文件未能编入索引",
      "coverageNotSettled": "覆盖检查未能完成加载。请关闭此窗口并使用重新检查。",
      "headerPreparing": "正在准备您的数据",
      "headerIngestFailed": "数据接入失败",
      "subtitleMayTake": "这可能需要几分钟时间……",
      "phraseInitializing": "正在初始化……",
      "fileStatusHeader": "文件状态",
      "fileStatusReady": "就绪",
      "fileStatusFailed": "失败",
      "fileStatusAttention": "需关注",
      "fileStatusPending": "待处理",
      "fileStatusIndexing": "索引中",
      "fileStatusIngesting": "摄取中",
      "ariaRetryFile": "重试 {{name}}",
      "tooltipRetry": "重试该文件",
      "tooltipRetryReingest": "重新开始该工作区的数据接入",
      "timeoutTitle": "处理时间超出预期",
      "timeoutBody": "处理可能仍在进行中。您可以再次检查，或关闭后稍后返回。",
      "timeoutRetry": "重试",
      "stillWorking": "仍在处理中——对于大型或含大量图像的文件，这可能需要几分钟时间。",
      "addTagPlaceholder": "添加标签……",
      "addTagButton": "添加",
      "fileTypeLabel": "类型：{{type}}",
      "needsReviewChip": "需要审阅",
      "errorMetadataPhase1": "元数据提取失败 — 请手动填写内容描述并点击「摄取数据」，或以支持的格式（PDF、DOCX）重新上传文件。",
      "errorPhase1NotRun": "未对此文件执行元数据提取 — 请手动填写内容描述并点击「摄取数据」，或重新上传文件。",
      "errorPhase2LlmFailed": "无法自动生成元数据 — 请审阅下方字段，填写缺失内容并点击「摄取数据」。",
      "errorVisionFailed": "无法自动描述此图片 — 请手动填写内容描述并点击「摄取数据」，或重新上传图片。",
      "errorStructuredFailed": "无法自动汇总此表格 — 请手动填写内容描述并点击「摄取数据」。",
      "errorPlanMappingFailed": "无法自动将此文件匹配到报告章节 — 请在下方选择其覆盖的章节并点击「摄取数据」。",
      "errorAttachmentExtractionFailed": "无法读取此邮件的附件 — 如报告需要，请将附件作为单独文件上传。",
      "errorImageIndexFailed": "此图片无法为检索做好准备，将不会出现在报告结果中 — 如报告需要，请重新上传。",
      "errorEnrichmentDefault": "丰富化未完成 — 请审阅并填写缺失字段。",
      "fieldHeaderField": "字段",
      "fieldHeaderValue": "值",
      "showLess": "收起",
      "advanced": "高级",
      "fieldYes": "是",
      "fieldNo": "否",
      "folderRoot": "（根目录）",
      "fileRetryFailed": "文件重试失败。请重试。",
      "phaseChipPhase": "阶段 {{phase}}",
      "reEnrichTitle": "{{count}} 个文件需要审阅",
      "reEnrichBody": "无法自动生成这些文件的详细信息。您可以在下方手动填写，或重新处理一次 — 已完成的文件不会受到影响。",
      "reEnrichButton": "重新处理",
      "reEnrichStarting": "正在启动…",
      "reEnrichRunning": "正在重新处理您的文件…",
      "reEnrichRunningBody": "这可能需要几分钟。下方文件会在各自完成后更新。",
      "reEnrichNothing": "没有需要处理的内容 — 这些文件已经更新。",
      "reEnrichFailed": "无法启动处理。请重试。",
      "reEnrichTimeoutTitle": "处理时间超出预期",
      "reEnrichTimeoutBody": "处理可能仍在进行中。您可以关闭后稍后返回，或重试。",
      "reEnrichRecheck": "重新检查",
      "reEnrichUnconfirmed": "无法确认处理是否已启动。当前状态如下所示。"
    },
    "reingestConfirm": {
      "title": "重新开始数据接入？",
      "body_one": "此操作将为工作区内的 <1>{{count}}</1> 个文件重新开始数据接入。",
      "body_other": "此操作将为工作区内的全部 <1>{{count}}</1> 个文件重新开始数据接入。",
      "hint": "所有文件都将被重新处理，包括已完成的文件。完整性将在之后重新评估。",
      "phaseBody_one": "此操作将为“{{phase}}”阶段的 <1>{{count}}</1> 个文件重新开始数据接入。",
      "phaseBody_other": "此操作将为“{{phase}}”阶段的全部 <1>{{count}}</1> 个文件重新开始数据接入。",
      "phaseHint": "此阶段的所有文件都将重新处理，包括已完成的文件。之后将重新检查此阶段的覆盖情况。",
      "confirm": "重新开始接入",
      "confirming": "正在重新开始……"
    },
    "testConfig": {
      "headerComposing": "正在编排测试流水线……",
      "headerExecutionPlan": "测试执行计划",
      "groupsIdentified_one": "已识别 {{count}} 个测试组",
      "groupsIdentified_other": "已识别 {{count}} 个测试组",
      "stage1Title": "正在分析计划章节并匹配工具……",
      "stage1Body": "正在查找可用工具、读取测试流程，并将计划章节归入测试组。",
      "stage2Title": "正在准备流水线{{suffix}}",
      "stage2TitleSuffix": "，针对第 {{progress}} 组",
      "stage2TitleSuffixDefault": "……",
      "stage2Body": "获取工具定义、编写流水线代码，并为每个测试组验证数据要求。",
      "stage2GroupCaption": "第 {{progress}} 组",
      "errorTitle": "测试计划编排失败",
      "errorWhatThisMeans": "<1>这意味着：</1>无法为该工作区生成可运行的测试计划。请重试，如问题持续请联系支持人员。",
      "errorNextStep": "<1>下一步：</1>请点击下方的“重试”。如果再次失败，请联系支持人员，并提供工作区名称和发生故障的时间。",
      "errorCompositionId": "composition_id:{{id}}",
      "compositionFailedDefault": "测试计划编排失败。",
      "noActionableResult": "无法为此工作区生成测试组。请重试，如问题持续请联系支持人员。",
      "compositionFailedTemplate": "编排测试计划失败：{{error}}",
      "compositionDoneNoGroups": "编排已完成，但未返回任何测试组。",
      "executionFailedTemplate": "测试执行失败：{{error}}",
      "partialFailureTitle_one": "部分编排：{{count}} 个组准备失败",
      "partialFailureTitle_other": "部分编排：{{count}} 个组准备失败",
      "partialFailureNote": "您可以继续使用已成功编排的组，或重新编排。",
      "coversSectionsLabel": "覆盖的计划章节：",
      "dataRequirementsHeader": "输入数据要求：",
      "pipelineCodeLabel": "流水线代码：",
      "pipelineExpand": "展开 / 编辑",
      "pipelineCollapse": "折叠",
      "uploadHeaderMulti": "上传测试数据（每组一个文件）",
      "uploadHintMulti": "每个测试组可能需要不同的数据形状。请上传与各组数据要求架构匹配的文件。支持 CSV、XLSX 或 Parquet。",
      "uploadSelectedLabel": "已选：{{name}}（{{size}} KB）",
      "uploadCoversShort": "覆盖：{{names}}{{ellipsis}}",
      "uploadChooseFileFor": "为该组选择文件",
      "uploadReplace": "替换",
      "uploadChooseFile": "选择文件",
      "uploadHeaderSingle": "上传测试数据（CSV、XLSX 或 Parquet）",
      "uploadSizeKb": "{{size}} KB",
      "uploadHintSingle": "点击浏览或拖放测试数据集",
      "footerSummaryGroups": "{{uploaded}}/{{total}} 个组已选择数据",
      "footerSummaryFile": "数据：{{name}}",
      "footerSummaryUpload": "请上传测试数据以继续",
      "footerTestsReady_one": "{{count}} 项测试就绪 | {{status}}",
      "footerTestsReady_other": "{{count}} 项测试就绪 | {{status}}",
      "running": "正在运行……",
      "runTests_one": "运行 {{count}} 项测试",
      "runTests_other": "运行 {{count}} 项测试",
      "cancel": "取消",
      "retry": "重试",
      "kernelLabel": "执行引擎：{{phase}}",
      "kernelGroupsCompleted": "{{passed}} / {{total}} 个组已完成",
      "kernelSpawning": "正在启动执行引擎……",
      "kernelReady": "执行引擎就绪 — 正在执行测试组……",
      "kernelExecuting": "正在通过执行引擎执行测试组……",
      "kernelInProgress": "测试执行进行中……",
      "executionFailedAlert": "测试执行失败或超时。您可以关闭此对话框并重试。",
      "footerTestsReady": "{{count}} 项测试就绪",
      "groupsIdentified": "已识别 {{count}} 个组",
      "partialFailureTitle": "部分失败",
      "runTests": "运行测试",
      "stage": "阶段"
    },
    "testResults": {
      "title": "测试运行结果",
      "subtitle": "在生成报告前审阅并批准制品",
      "allApprovedTitle": "所有测试已批准！",
      "allApprovedBody": "测试制品已索引完毕，可用于报告生成。",
      "downloadCsv": "下载 CSV",
      "generateReport": "生成报告",
      "noArtifactsTitle": "无可展示的制品",
      "executionInProgressTitle": "测试执行进行中……",
      "executionInProgressBody": "执行完成后，结果将显示在此处。",
      "noArtifactsBody": "工具结果已作为源数据文件编目，可用于报告生成。",
      "submitApprovals": "提交批准",
      "submitting": "正在提交……",
      "cancel": "取消",
      "submitFailed": "提交批准失败。请重试。",
      "passLabel": "通过",
      "failLabel": "失败",
      "untitledArtifact": "工具 {{n}}",
      "kernelArtifactDefault": "执行制品",
      "errorLabel": "错误",
      "noStructuredOutput": "执行已完成 — 无结构化输出。",
      "resultTooLarge": "结果数据过大，无法内联显示。请使用「下载 CSV」获取完整输出。",
      "flaggedCells_one": "{{count}} 个标记的单元格",
      "flaggedCells_other": "{{count}} 个标记的单元格",
      "sectionLabelDefault": "第 {{n}} 节",
      "unexplainedPercent": "{{value}}% 未解释",
      "triggered": "已触发",
      "ok": "正常",
      "emptyText": "（空）",
      "flaggedCells": "标记的单元格"
    }
  },
  "softWarnings": {
    "ariaLabel": "导出软警告",
    "title_one": "上次导出产生了 {{count}} 条软警告",
    "title_other": "上次导出产生了 {{count}} 条软警告",
    "intro": "导出已成功完成，但文档渲染器对以下项目发出了提示。文件可正常下载；下一次导出将重新评估这些信号。",
    "sectionLabel": "章节 {{id}}:",
    "sectionLabelTitled": "{{title}}：",
    "kinds": {
      "pandoc_stderr": "文档渲染器在此章节中报告了一个问题。",
      "image_embed_failed": "此章节中的一张图片未能包含在导出文件中。",
      "generic": "文档渲染器报告了一个问题。"
    },
    "truncated": "另有 {{count}} 条警告未显示"
  },
  "templateStyle": {
    "titlePartial": "模板样式部分保留",
    "titleFailed": "模板样式保留失败",
    "ariaWarning": "模板样式保留警告",
    "bodyPartialPrefix": "{{warning}} 您模板的字体和间距仍将应用到导出的报告中 — 封面和章节布局将使用默认设置。",
    "bodyPartialDefault": "无法保留模板结构。",
    "bodyFailedPrefix": "{{warning}} 不影响内容生成。",
    "bodyFailedDefault": "导出时将应用通用样式。"
  },
  "sectionsTab": {
    "outputTemplateTitle": "输出模板",
    "outputTemplateOptional": "（可选）",
    "outputTemplateHelp": "上传模板文件以锚定报告的结构和样式。",
    "uploadOutputTemplateLabel": "上传输出模板",
    "modelDevelopmentReportTitle": "模型开发报告",
    "mdrInheritedHelp": "本工作区的源文件包含其父模型的最新模型开发报告，无论已批准还是待批准。",
    "mdrInheritedLoading": "正在查询本工作区继承的模型开发报告…",
    "mdrInheritedUnreadable": "暂时无法读取继承的模型开发报告，因此本工作区无法显示其继承的内容。",
    "mdrInheritedNoneApproved": "本工作区目前没有生效的模型开发报告。其父模型尚无已批准或待审批的版本，因此计划生成将在没有报告的情况下运行。",
    "mdrInheritedPendingApproval": "本工作区的父模型有一份待审批的开发报告。计划生成将最新版本作为未批准的草稿参考使用。",
    "mdrInheritedNotModelRooted": "本工作区创建于工作区归属模型之前，因此没有可供继承开发报告的父模型。计划生成将在没有报告的情况下运行。",
    "mdrInheritedVersionMeta": "版本 {{versionId}} · 上传于 {{uploadedAt}}",
    "mdrInheritedOpenModel": "打开模型的开发报告",
    "uploadTaskDescriptionLabel": "上传任务描述",
    "taskDescriptionTitle": "任务描述",
    "taskDescriptionHelp": "上传一个 Markdown 或文档文件，描述工作范围。",
    "taskDescriptionHelp_validation": "上传一个 Markdown 或文档文件，描述验证范围。",
    "taskDescriptionHelp_auditing": "上传一个 Markdown 或文档文件，描述审计范围。",
    "taskDescriptionHelp_development": "上传一个 Markdown 或文档文件，描述开发范围。",
    "sectionPhase": {
      "extractingSymptoms": "正在提取症状……",
      "aggregatingIssues": "正在聚合问题……",
      "holisticValidating": "正在进行整体自检……",
      "execSumGenerating": "正在生成执行摘要……"
    },
    "sectionStatus": {
      "pending": "待处理",
      "in_progress": "进行中",
      "context_ready": "上下文就绪",
      "context_unavailable": "上下文不可用",
      "generating": "生成中",
      "generated": "已生成",
      "pending_validation": "等待自检",
      "validating": "自检中",
      "validation_skipped": "自检已跳过",
      "validated": "已自检",
      "approved": "已批准",
      "user_accepted_as_gap": "已接受为缺口",
      "needs_regen": "需要重新生成",
      "failed": "失败",
      "generation_failed": "生成失败",
      "pending_phase_2c": "待处理",
      "generation_stopped": "已停止"
    }
  },
  "markComplete": {
    "button": {
      "label": "标记为完成"
    },
    "modal": {
      "title": "将工作区标记为已完成？",
      "body": "将工作区标记为已完成会锁定所有变更操作。仅当您希望锁定工作区上下文以供未来审计时执行此操作。确定要继续吗？",
      "cancel": "取消",
      "confirm": "确认",
      "success": "工作区已标记为完成。",
      "alreadyComplete": "工作区已是完成状态。"
    }
  },
  "reportPreview": {
    "versionPagerMismatch": "此章节的 v{{currentVersion}} 版本已不可用。请尝试刷新该章节。"
  },
  "dataPanel": {
    "ineligibility": {
      "archived": "该项目已归档，无法接收新的源数据。",
      "model_archived": "该项目所属的模型已归档，因此该项目无法接收新的源数据。",
      "no_workflow_state": "该项目尚未完成设置，暂时无处存放源数据。",
      "report_generation_started": "报告生成已开始，该项目不再接收新的源数据。",
      "workspace_terminal": "此项目已完成，无法再添加新的源数据。",
      "failed_state": "请先处理该项目失败的步骤，然后再添加源数据。",
      "workspace_busy": "该项目正忙——请等待当前步骤完成后再添加源数据。",
      "workspace_busy_before_plan": "计划获批后即可添加源数据。",
      "default": "该项目当前无法接收新的源数据。"
    },
    "unavailable": "无法确认您可以对该项目的数据执行哪些操作。请刷新后重试。"
  },
  "exportVersion": {
    "label": "导出版本",
    "none": "选择一个版本"
  },
  "reportVersions": {
    "busy": "正在生成报告，完成后即可开始新版本。",
    "collectionNotSettled": "文件处理完成后即可开始新版本。",
    "filesChanged": "自报告 V{{version}} 以来参考文件已变更：新增 {{added}} 个，移除 {{removed}} 个。生成新版本以包含这些变更。",
    "rejectedFilesNotice_one": "有 {{count}} 个文件因格式不受支持而未被摄取，因此报告 V{{version}} 在生成时未包含这些文件。请上传这些数据的 CSV 或 JSON 导出文件，以便在新版本中包含它们。",
    "rejectedFilesNotice_other": "有 {{count}} 个文件因格式不受支持而未被摄取，因此报告 V{{version}} 在生成时未包含这些文件。请上传这些数据的 CSV 或 JSON 导出文件，以便在新版本中包含它们。",
    "failed": {
      "report_generation_cancelled": "此版本在完成前已停止。上一版本保持不变。请生成新版本。",
      "report_generation_cancelled_first": "此版本在完成前已停止。请生成新版本。",
      "generic": "无法生成此版本。上一版本保持不变。请生成新版本。",
      "generic_first": "无法生成此版本。请生成新版本。",
      "halted": "此版本已停止，因为上游问题暂停了生成。上一版本保持不变。请使用“{{clearHalt}}”恢复，然后生成新版本。",
      "halted_first": "此版本已停止，因为上游问题暂停了生成。请使用“{{clearHalt}}”恢复，然后生成新版本。"
    }
  }
}
